module.exports = __webpack_public_path__ + "static/media/Tri-Fold-Brochure-PSD-Mockup.11e4c45a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/primus/Tri-Fold-Brochure-PSD-Mockup.jpg
// module id = 434
// module chunks = 0